// src/App.js
import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './assets/styles/SimulacrumImagesStyle.css';
import SimulacrumImagesNavbar from "./components/SimulacrumImagesNavbar";
import SimulacrumImagesFooter from "./components/SimulacrumImagesFooter";
import RouteMetadata from "./components/RouteMetadata";

const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Services = lazy(() => import('./pages/Services'));
const Contact = lazy(() => import('./pages/Contact'));
const GoodMorningBlockChainBook = lazy(() => import('./pages/GoodMorningBlockChainBook'));
const Glossary = lazy(() => import('./pages/Glossary'));
const ArticleList = lazy(() => import('./pages/ArticleList'));
const ArticleDetails = lazy(() => import('./pages/ArticleDetails'));
const MimesisCastlePage = lazy(() => import('./pages/MimesisCastlePage'));
const Galleries = lazy(() => import('./pages/Galleries'));
const GMWeb3Course = lazy(() => import('./pages/GmBlockchainLiveWorkshop'));
const PrivacyPolicy = lazy(() => import('./pages/TheCrumExplorerPrivacy'));
const Copyright = lazy(() => import('./pages/TheCrumbExplorerCopyright'));
const TermsOfUse = lazy(() => import('./pages/TheCrumbExplorerTermsOfUse'));
const GodOfThunderPage = lazy(() => import('./pages/GodOfThunderPage'));
const BunnyRunnerPage = lazy(() => import('./pages/BunnyRunnerPage'));
const SuspiciousMicrowaveTDPage = lazy(() => import('./pages/SuspiciousMicrowaveTDPage'));
const SuspiciousMicrowaveTermsOfService = lazy(() => import('./pages/SuspiciousMicrowaveTermsOfService'));
const SuspiciousMicrowaveTDPrivacyPolicy = lazy(() => import('./pages/SuspiciousMicrowaveTDPrivacyPolicy'));
const NotFound = lazy(() => import('./pages/NotFound'));

function App() {
    return (
        <Router>
            <RouteMetadata />
            <SimulacrumImagesNavbar />
            <main id="main-content" className="main-body-container" tabIndex={-1}>
                <Suspense fallback={<div role="status">Loading page...</div>}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/glossary" element={<Glossary />} />
                        <Route path="/gm-blockchain" element={<GoodMorningBlockChainBook />} />
                        <Route path="/gm-web3-course" element={<GMWeb3Course />} />
                        <Route path="/articles" element={<ArticleList />} />
                        <Route path="/articles/:id" element={<ArticleDetails />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/mimesis-castle" element={<MimesisCastlePage />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/galleries" element={<Galleries/>}/>
                        <Route path="/god-of-thunder" element={<GodOfThunderPage />} />
                        <Route path="/bunny-runner" element={<BunnyRunnerPage />} />
                        <Route path="/suspicious-microwave-td" element={<SuspiciousMicrowaveTDPage />} />
                        <Route
                            path="/suspicious-microwave-terms-of-service"
                            element={<SuspiciousMicrowaveTermsOfService />}
                        />
                        <Route
                            path="/suspicious-microwave-privacy-policy"
                            element={<SuspiciousMicrowaveTDPrivacyPolicy />}
                        />

                        <Route path="/terms" element={<TermsOfUse />} />
                        <Route path="/privacy" element={<PrivacyPolicy />} />
                        <Route path="/copyright" element={<Copyright />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </Suspense>
            </main>
            <SimulacrumImagesFooter />
        </Router>
    );
}

export default App;
